import PropTypes from 'prop-types';
import { TAB_VIEW_SECTIONS, TABS } from './constants';

const { FEATURES } = TAB_VIEW_SECTIONS[TABS.OVERVIEW];

export const crossSellPropTypes = PropTypes.shape({
  crossSellRadius: PropTypes.number,
  crossSellReferralSource: PropTypes.string,
  nearbyPropertiesExcludedProperties: PropTypes.arrayOf(PropTypes.number),
  properties: PropTypes.arrayOf(
    PropTypes.shape({
      distance: PropTypes.number,
      id: PropTypes.number,
      name: PropTypes.string,
      unit: PropTypes.string,
    }),
  ),
  referralSourceOptions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    }),
  ),
});

export const guestCardRequirementsPropTypes = PropTypes.shape({
  requireLeaseTerm: PropTypes.bool,
  requirePreferredBedroomCount: PropTypes.bool,
  requirePreferredUnit: PropTypes.bool,
  requireProspectFloorplan: PropTypes.bool,
  requireProspectMoveInDate: PropTypes.bool,
});

export const selfGuidedToursPropTypes = PropTypes.shape({
  toursExportOnlyFavoriteUnit: PropTypes.bool,
  selfGuidedTourUrl: PropTypes.string,
  selfGuidedTourButtonLabel: PropTypes.string,
});

export const advancedSettingsPropTypes = PropTypes.shape({
  crossSell: crossSellPropTypes,
  guestCardRequirements: guestCardRequirementsPropTypes,
  selfGuidedTours: selfGuidedToursPropTypes,
});

export const affordablePropTypes = PropTypes.shape({
  details: PropTypes.string,
  incomeEligibility: PropTypes.arrayOf(
    PropTypes.shape({
      maximumIncome: PropTypes.string,
      occupants: PropTypes.string,
    }),
  ),
});

export const contactInfoPropTypes = PropTypes.shape({
  knockEmail: PropTypes.string,
  owner: PropTypes.string,
});

export const marketingMedia = PropTypes.shape({
  logos: PropTypes.arrayOf(
    PropTypes.shape({
      thumbUrl: PropTypes.string,
      url: PropTypes.string,
    }),
  ),
  photos: PropTypes.arrayOf(
    PropTypes.shape({
      clUrl: PropTypes.string,
      description: PropTypes.string,
      thumbUrl: PropTypes.string,
      url: PropTypes.string,
    }),
  ),
  social: PropTypes.shape({
    customLinks: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        url: PropTypes.string,
      }),
    ),
    facebook: PropTypes.string,
    instagram: PropTypes.string,
    propertyWebsite: PropTypes.string,
    video: PropTypes.string,
    x: PropTypes.string,
    yelp: PropTypes.string,
  }),
});

export const propertyDetailsPropTypes = PropTypes.shape({
  city: PropTypes.string,
  description: PropTypes.string,
  neighborhood: PropTypes.string,
  propertyName: PropTypes.string,
  state: PropTypes.string,
  street: PropTypes.string,
  totalUnits: PropTypes.number,
  unitTypes: PropTypes.arrayOf(PropTypes.string),
  yearBuilt: PropTypes.string,
  zip: PropTypes.string,
});

export const notesFeaturesPropTypes = PropTypes.shape({
  community: PropTypes.arrayOf(PropTypes.string),
  location: PropTypes.arrayOf(PropTypes.string),
  notes: PropTypes.string,
  units: PropTypes.arrayOf(PropTypes.string),
});

export const overviewPropTypes = PropTypes.shape({
  contactInfo: contactInfoPropTypes,
  [FEATURES]: notesFeaturesPropTypes,
  marketingMedia: marketingMedia,
  propertyDetails: propertyDetailsPropTypes,
});

export const amenitiesPropTypes = PropTypes.shape({});
export const leasingPropTypes = PropTypes.shape({});

export const propertyPropTypes = PropTypes.shape({
  advanced_settings: advancedSettingsPropTypes,
  affordable: affordablePropTypes,
  amenities: amenitiesPropTypes,
  leasing: leasingPropTypes,
  overview: overviewPropTypes,
  propertyId: PropTypes.number,
});
